import { useRef, useState } from "react";
import { provisionLookup } from "../firebase/provision";

// Identifier-first sign-in: the email's provision decides password vs.
// district sign-in. Pages look it up on email blur and again on submit; the
// latest lookup wins.
export const useSsoLookup = () => {
  const [ssoProviderId, setSsoProviderId] = useState(null);
  const latest = useRef(0);

  const checkEmail = async (email) => {
    const call = ++latest.current;
    const result = await provisionLookup(email);
    if (call === latest.current) setSsoProviderId(result.ssoProviderId);
    return result;
  };

  return { ssoProviderId, setSsoProviderId, checkEmail };
};
